<template lang="pug">
section
  s-page-title(title='Статьи')
    template(slot='extension')
      v-btn(@click='onEdit()', color='primary', depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch', :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(v-if='attributes.regions', xs-6, style='max-width: 50%')
            v-select(
              :items='attributes.regions',
              :value='dataFilter.region_id',
              @change='setRegion',
              item-value='id',
              item-text='region_name',
              label='Регион',
              returnObject,
              clearable
            )
          v-flex(v-if='attributes.categories', xs-6, style='max-width: 50%')
            v-select(
              :items='attributes.categories',
              :value='dataFilter.category_id',
              @change='setCategory',
              item-value='id',
              item-text='name',
              label='Категория',
              returnObject,
              clearable
            )

    v-data-table(
      :loading='isLoading',
      :headers='headers',
      :items='list',
      :total-items='total',
      :pagination='dataFilter',
      @update:pagination='updatePagination'
    )
      template(slot='items', slot-scope='props')
        tr.with-pointer(@click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.ratingValue }}
          td {{ props.item.name }}
          td {{ props.item.category_name }}
          td {{ props.item.regions }}
          td {{ props.item.content_type }}
          td.text-xs-right.wrapless.crud-tools
            v-btn(icon, @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item',
              @success='fetch',
              resource='seo/blogs'
            )
</template>

<script>
import http from '@/http'
import { debounce, get } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    attributes: {},
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true,
      },
      {
        text: 'Рейтинг',
        align: 'center',
        sortable: true,
        value: 'ratingValue',
      },
      {
        text: 'Название',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Категория',
        align: 'left',
        sortable: true,
        value: 'category_name',
      },
      {
        text: 'Регионы',
        align: 'left',
        sortable: true,
        value: 'regions',
      },
      {
        text: 'Тип контента',
        align: 'left',
        sortable: true,
        value: 'content_type',
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false,
      },
    ],
  }),

  created() {
    this.fetch()
    this.fetchAttributes()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setRegion(region) {
      const region_id = get(region, 'id', null)
      this.setDataFilter({ region_id })
      this.fetch()
    },

    setCategory(category) {
      const category_id = get(category, 'id', null)
      this.setDataFilter({ category_id })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.Blog.Edit',
        params: { id },
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter,
        },
      })
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/seo/blogs/attributes')
        this.attributes = res.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки справочников')
      }
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function (search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('seo/blog', ['fetchList', 'destroy']),
    ...mapMutations('seo/blog', ['setDataFilter']),
  },

  computed: {
    ...mapState('seo/blog', ['total', 'dataFilter']),
    ...mapGetters('seo/blog', ['list', 'isLoading']),
  },
}
</script>
